/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import metadata from './MLPUPAnimalLiabilityExclusionsComponent.metadata.json5';
import './MLPUPAnimalLiabilityExclusionsComponent.messages';

// Component is always non editable even in custom quote
function MLPUPAnimalLiabilityExclusionsComponent(props) {
    const {
        items,
        readOnly,
        getTypeKeyDescription,
        getYesNoAnswer
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const breedTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('AnimalBreed_PUE');
    const typeTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('AnimalType_PUE');

    const generateItemOverrides = () => {
        const itemOverrides = items.map((item, itemIndex) => {
            return {
                [`hasBittenContent${itemIndex}`]: {
                    content: getYesNoAnswer(item.hasBitten)
                },
                [`breedContent${itemIndex}`]: {
                    content: getTypeKeyDescription(breedTypelist.getCode(item.breed).name)
                },
                [`typeContent${itemIndex}`]: {
                    content: getTypeKeyDescription(typeTypelist.getCode(item.type).name)
                }
            };
        });

        return Object.assign({}, ...itemOverrides);
    };

    const overrides = {
        stackTableDiv: {
            className: readOnly ? 'stack-table' : 'stack-table plain'
        },
        tableRowIterable: {
            data: items
        },
        ...generateItemOverrides()
    };


    const resolvers = {};

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLPUPAnimalLiabilityExclusionsComponent.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    readOnly: PropTypes.bool,
    getTypeKeyDescription: PropTypes.func.isRequired,
    getYesNoAnswer: PropTypes.func.isRequired
};

export default MLPUPAnimalLiabilityExclusionsComponent;
